export default __webpack_public_path__ + "static/media/android.b475e907.png";